import { STATE_SELECTOR } from '../constants';

const initialState = {
    currentStateResidence: "",
    submissionOnBehalfOf: "",
    customerRelation: "",
    bentleyCustomer: "",
    brandAffiliation: "",
    requestType:"",
    selectedFlow: "",
    isAgentSubmission: false,
    agentInfo: {},
}

const stateSelectorReducer = (state = initialState, action) => {
    const { payload, type } = action;
    switch (type) {
        case STATE_SELECTOR.STATE_SELECTOR_LOAD:
            return {
                ...state,
                currentStateResidence: "",
                submissionOnBehalfOf: "",
                customerRelation: "",
                bentleyCustomer: "",
                brandAffiliation: "",
                requestType:"",
                selectedFlow: "",
                isAgentSubmission: false,
                agentInfo: {},
            }
        case STATE_SELECTOR.STATE_SELECTOR_SUCCESS:
            return {
                ...state,
                currentStateResidence: payload.currentStateResidence,
                submissionOnBehalfOf: payload.submissionOnBehalfOf,
                customerRelation: payload.customerRelation,
                bentleyCustomer: payload.bentleyCustomer,
                brandAffiliation: payload.brandAffiliation,
                requestType: payload.requestType,
                selectedFlow: payload.selectedFlow,
                isAgentSubmission: payload.isAgentSubmission || false,
                agentInfo: payload.agentInfo || {},
            }
        case STATE_SELECTOR.STATE_SELECTOR_RESET:
            return {
                ...state,
                currentStateResidence: "",
                submissionOnBehalfOf: "",
                customerRelation: "",
                bentleyCustomer: "",
                brandAffiliation: "",
                requestType:"",
                selectedFlow: "",
                isAgentSubmission: false,
                agentInfo: {},
            }
        case STATE_SELECTOR.STATE_SELECTOR_FAIL:
            return {
                ...state,
                currentStateResidence: "",
                submissionOnBehalfOf: "",
                customerRelation: "",
                bentleyCustomer: "",
                brandAffiliation: "",
                requestType:"",
                selectedFlow: "",
                isAgentSubmission: false,
                agentInfo: {},
            }
        default:
            return state;
    }
}
export default stateSelectorReducer